import { FundoListItem } from '../../screens/cadastros/fundo_liquido/mock';
import { listarFundos } from '../../screens/cadastros/fundo_liquido/fundosService';

export interface Notificacao {
  id: string;
  titulo: string;
  descricao: string;
  href: string;
}

// Campo-chave vazio (inclui o placeholder "—" usado na listagem).
const vazio = (s?: string): boolean => !s || !s.trim() || s.trim() === '—';

// Campos-chave que, se vazios, deixam o cadastro do fundo "pendente de informação".
const camposPendentes = (f: FundoListItem): string[] => {
  const faltando: string[] = [];
  if (vazio(f.administradora)) faltando.push('Administrador');
  if (vazio(f.gestor)) faltando.push('Gestor');
  if (vazio(f.classe_anga_1)) faltando.push('Classe ANGA');
  if (vazio(f.codigo_anbima)) faltando.push('Código ANBIMA');
  return faltando;
};

// Notificações de cadastros pendentes (fundos com campos-chave vazios).
export async function carregarNotificacoes(): Promise<Notificacao[]> {
  const fundos = await listarFundos();
  return fundos
    .map((f) => ({ f, faltando: camposPendentes(f) }))
    .filter((x) => x.faltando.length > 0)
    .map(({ f, faltando }) => ({
      id: `fundo-${f.id}`,
      titulo: f.nome_fantasia || f.razao_social || f.cnpj || `Fundo #${f.id}`,
      descricao: `Falta: ${faltando.join(', ')}`,
      href: `/cadastro/fundo/liquidos/${f.id}`,
    }));
}
